import { PageHeader, Spinner } from '@fukuri-admins/ui/common';
import clsx from 'clsx';
import { Suspense } from 'react';
import { IS_STRESS_CHECK_IMPLEMENTER_BUILD } from '~/constants';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { StressAssessmentSchedule } from '~/features/StressAssessmentSchedule';
import { StressAssessmentScheduleNotificationBanner } from '~/features/StressAssessmentScheduleNotificationBanner';
import { ROUTES } from '~/utils/routes';
import styles from './styles.module.scss';

export const Screen: React.FC = () => {
  return (
    <div
      className={clsx(styles.screen, {
        [styles.NoSideMenu]: IS_STRESS_CHECK_IMPLEMENTER_BUILD,
      })}
    >
      {!IS_STRESS_CHECK_IMPLEMENTER_BUILD && <ClientSideMenu />}
      <div className={styles.content}>
        <PageHeader
          variant='breadcrumb'
          breadcrumbItems={[
            { label: 'ストレスチェック', href: ROUTES.STRESS_ASSESSMENTS.INDEX },
            { label: 'スケジュールの設定' },
          ]}
        />
        <main className={styles.body}>
          <Suspense fallback={<Spinner />}>
            <StressAssessmentSchedule />
          </Suspense>
        </main>
        {!IS_STRESS_CHECK_IMPLEMENTER_BUILD && (
          <div className={styles.BannerWrapper}>
            <Suspense fallback={null}>
              <StressAssessmentScheduleNotificationBanner />
            </Suspense>
          </div>
        )}
      </div>
    </div>
  );
};
